import React from 'react';
import useUserStore from 'src/store/useUserStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { getDashboardComponent } from './dashboardRegistry';

const FixedPage: React.FC = () => {
  const { userInfo } = useUserStore();
  const { loadingSpinner } = useLoadingSpinnerStore();

  if (loadingSpinner || !userInfo) {
    return null;
  }

  // dashboardType 값에 따라 렌더링할 대시보드 컴포넌트를 registry 에서 조회한다.
  // (등록되지 않은 값이거나 비어있으면 DefaultPage 로 폴백)
  const DashboardComponent = getDashboardComponent(userInfo.dashboardType);

  return <DashboardComponent />;
};

export default FixedPage;
